'use client';

import { useEffect, useState } from 'react';
import { isNativePlatform } from './is-native';

export function useIsNative(): boolean {
  const [isNative, setIsNative] = useState(false);

  useEffect(() => {
    setIsNative(isNativePlatform());
  }, []);

  return isNative;
}
